// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".surroundProgress[data-v-70463682] .relocate_legend{position:absolute;bottom:-45px}.player-avatar[data-v-70463682]{margin:auto;min-width:90px;position:relative}.player-avatar .text-center[data-v-70463682]{text-align:center}.player-avatar .difference[data-v-70463682]{position:absolute;top:0;left:0}.player-avatar .injured-badge[data-v-70463682]{position:absolute;bottom:20px;right:0;width:20px}", ""]);
// Exports
module.exports = exports;
